import React from 'react';

const Template = (props) => {
    const { list, activeKey } = props;

    const showList = list.map((i) => i.key);

    return (
        <>
            {React.Children.map(props.children, (child, index) => {
                if (!child) return null;
                if (!showList.includes(child.props.cardId)) return null;
                if (activeKey !== child.props.cardId) return null;
                return child;
            })}
        </>
    );
};

export default Template;
